/**
 * Valor por defecto para la cobertura Básica.
 * @const
 * @default "80000" Dato: Todas las coberturas tienen como valor predeterminado el valor que tenga la cobertura básica por defecto, sea cual sea.
 */
export const PROTECTION_OPTIONS = {
  DEFAULT_VALUE: 80000
};
